module.exports = __webpack_public_path__ + "static/award3-b00d5fc62a72a148b9facc9b10ac3234.png";